//@commons
const { APIPost } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');

const getCardsInformation = (publicInformation) => dispatch => {
    const cards = get(publicInformation, 'datosSalidaTarjetas.tarjetas', [])

    if ( cards.length === 0 ){
        return Promise.resolve(publicInformation);
    }

    //Dispatch a request for every contract (returns an array of promises)=
    const allCardInformationPromises = cards.map((card) => {

        let tipoTarjeta;
        if (!!card.tipoa) {
            tipoTarjeta = card.tipoa;
        }
        const params = {
            header: { 
                version: 3 
            },
            query: {
                tipoTarjeta,
                pan: card.panmdp,
                numeroContrato: card.contrato.numerodecontrato,
                producto: card.contrato.producto
            }
        };

        return APIPost({
            dispatch,
            params,
            endpoint: 'cardInformation'
        });
    })

    return Promise.all(allCardInformationPromises)
        .then((cards) => {
            const parsedCards = cards.map((cardInfo, index) => {
                if ( !cardInfo || !!cardInfo.error ){
                    return publicInformation.datosSalidaTarjetas.tarjetas[index];
                }

                return Object.assign({}, publicInformation.datosSalidaTarjetas.tarjetas[index], cardInfo);
            });

            publicInformation.datosSalidaTarjetas.tarjetas = parsedCards;
            return publicInformation;
        });
};

module.exports = {
    getCardsInformation
};
